/** "45m", "2h", "2h 15m". */
export function formatDurationHm(minutes: number): string {
  const h = Math.floor(minutes / 60)
  const m = Math.round(minutes % 60)
  if (h === 0) return `${m}m`
  if (m === 0) return `${h}h`
  return `${h}h ${m}m`
}

const STOP_TYPE_LABELS: Record<string, string> = {
  shipper_collection: "Collection",
  haulage_collection: "Haulage Collection",
  haulage_delivery: "Haulage Delivery",
  depot_injection: "Depot Injection",
  direct_injection: "Direct Injection",
  internal_stop: "Internal",
  charging_stop: "Charging Stop",
}

export function stopTypeLabel(t: string): string {
  return STOP_TYPE_LABELS[t] || t
}
